const testData = [
    {
        pin: 'J2rTkV34-0',
        owner: 'riet'
    },
    {
        pin: 'JhrRCS4e-1',
        owner: 'riet'
    },
    {
        pin: '5ZkS42cf-2',
        owner: 'riet'
    },
    {
        pin: 'OZyS420E-3',
        owner: 'riet'
    },
    {
        pin: 'a7P5oxL7-4',
        owner: 'riet'
    },
    {
        pin: 'buwbkBy1-5',
        owner: 'riet'
    }
];

export default testData;